<template>
  <KfDesktop>
    <template #appGrid>
      <GroupDesktop/>
    </template>
  </KfDesktop>
</template>
<script>
import GroupDesktop from "@/views/GroupDesktop.vue";

const messages = {
  zhCn: {
    badge_error: 'Badge消息加载失败，{msg}',
  },
  zhTw: {
    badge_error: 'Badge消息加載失敗，{msg}',
  },
  en: {
    badge_error: 'Badge message failed to load, {msg}',
  }
}

export default {
  name: 'Desktop',
  components: {GroupDesktop},
  i18n: {messages},
  data() {
    return {
      pollingTimer: null
    }
  },
  async created() {
    await this.loadConfig()

    let user = await this.$http('sysUserService.getCurrentUser');
    this.$store.commit('core/CURRENT_USER_INIT', user)

    this.loadDefinition()
    this.getUserApps();

    let data = await this.$http('sysDictService.selectAll')
    this.$store.commit('core/INIT_DICT', data)
  },
  methods: {
    polling() {
      let pollingTime = parseInt(this.$store.getters['core/getConfig']('polling_time')) || 0;
      if (pollingTime < 1 || this.pollingTimer) {
        return;
      }

      this.pollingTimer = setInterval(async () => {
        let dataKeys = this.$store.getters['core/getBadgeDataKeyList'];
        if (dataKeys.length == 0) {
          return;
        }

        this.$http('framePollingService.getPollingData', {data_keys: dataKeys}, false).then(data => {
          this.$store.commit('core/INIT_BADGE', data)
          let msg = this.$store.getters['core/getBadgeData']('one_un_send_msg');
          if (msg) {
            this.$notify.info({
              title: "收到新消息",
              message: msg.title,
              duration: 0
            })
          }

          let waitReceiveMaterialCnt = this.$store.getters['core/getBadgeData']('wait_receive_material_cnt') || 0;
          if (waitReceiveMaterialCnt) {
            this.$notify.info({
              title: "领料提示",
              message: `您有${waitReceiveMaterialCnt}个申请单已发料，请领料并做接收操作。`,
              duration: pollingTime * 1000
            })
          }
        }, errMsg => {
          return this.$message.error(`Badge消息加载失败，${errMsg}`);
        })
      }, pollingTime * 1000)

    },
    async loadDefinition() {
      let data = await this.$http('frameUiService.loadDefinition')
      this.$store.commit('core/QUERY_DEF_INIT', data.queryList)
      this.$store.commit('core/TABLE_DEF_INIT', data.tableList)
      this.$store.commit('core/FORM_DEF_INIT', data.formList)
    },
    async loadConfig() {
      let data = await this.$http('sysConfigService.getWebConfig')
      this.$store.commit('core/INIT_SYS_CONFIG', data)
      this.$store.commit('wallpaper/INIT_CONFIG', data)
      document.title = this.$store.getters['core/getAppName']

      this.polling()
    },
    async getUserApps() {
      let data = await this.$http('frameUiService.getUserApps');
      this.$store.commit('core/INIT_USER_APP', data)
    }

  },
  unmounted() {
    clearInterval(this.pollingTimer)
  }
};
</script>

<style lang="less" scoped>

</style>
